"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _richTextField = require("../../lib/richTextField");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to list finpro agents
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.statelist state list to display
 *
 * @returns {React.ReactElement} list of agents
 */
function ResultNotFound(props) {
  if (!props || (0, _lodash.isEmpty)(props.noResultMessage)) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container no-result text-padding"
  }, /*#__PURE__*/_react.default.createElement("h3", null, (0, _richTextField.parseHTML)(props.noResultMessage)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("strong", null, "Tips for improving the results:")), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Enter a City ", /*#__PURE__*/_react.default.createElement("strong", {
    style: {
      marginRight: 0
    }
  }, "and"), " State."), /*#__PURE__*/_react.default.createElement("li", null, "Try a ZIP code."), /*#__PURE__*/_react.default.createElement("li", null, "Make sure all words are spelled correctly."), !props.isMmfa && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-inline",
    href: "/us"
  }, "Select an agency by state.")))));
}
var _default = exports.default = ResultNotFound;